import { CircularProgress, CircularProgressProps } from '@mui/material'

const Loading = (props: CircularProgressProps) => (
  <CircularProgress {...props} sx={{margin: '20px'}} />
)

export default Loading